import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledDescription, StyledItem, StyledIcon, StyledInner, StyledTitle, StyledItemWrapper } from "./styles";

const CreateProfileDropdownItem = (props: { id: string; onClick(): void }) => {
    return (
        <StyledItemWrapper {...props}>
            <StyledItem>
                <StyledIcon
                    iconName="add"
                    size="sm"
                />
                <StyledInner>
                    <I18n
                        element={StyledTitle}
                        translatable={{
                            key: "si.account-overview.employee-profiles.dropdown.create-item.title",
                        }}
                    />
                    <I18n
                        element={StyledDescription}
                        translatable={{
                            key: "si.account-overview.employee-profiles.dropdown.create-item.description",
                        }}
                    />
                </StyledInner>
            </StyledItem>
        </StyledItemWrapper>
    );
};

export default CreateProfileDropdownItem;
